<script lang="ts">
    import { oidcToken, user } from "../stores";
    import {getContext} from "svelte";
    import UserDetailModal from "../modals/UserDetailModal.svelte";

    const {open} = getContext('simple-modal');

    function handleLogout() {
      $oidcToken = null;
      localStorage.removeItem("onecatalog-admin-token");
      $user.scaName = null
      $user.userType = null
    }

    function onUserClick() {
        open(UserDetailModal);
    }

</script>

<style lang="scss">
  @import "../styles/variables.scss";
  .navbar {
    border-bottom: 3px solid $dark-black;
    .user {
      margin: auto;
      padding: 7px;
      border-radius: 12px;
      transition: 0.3s ease;
      &:hover {
        background-color: $dark-green;
        color: white;
        cursor: pointer;
      }
      &:active {
        filter: brightness(0.8);
      }
    }
    .header-title {
      font-size: 1.1em;
      font-weight: bold;
      color: $dark-black;
    }

    .button.logout {
        background-color: $red;
        color: white;
        border-radius: 12px;
        &:hover {
            background-color: white;
            color: $red;
            border-color: $red;
        }
    }

  }
</style>

<nav class="navbar" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="https://www.nanotera.eu/" target="_blank">
        <img src="/nanotera.svg" alt="nanotera-logo" width="112" height="28">
      </a>
      <a class="navbar-item header-title" href="/admin">
        <span class="header-title navbar-item">
            OneCatalog
          </span>
      </a>
    </div>
  
    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-end">
        <div class="user" on:click={onUserClick} title="Cliquez pour plus de détails">
          <i class="fas fa-user"></i> {$user.getUser().name}
        </div>
        <div class="navbar-item">
          <div class="buttons">
            <button class="button logout" on:click={handleLogout}>Se déconnecter</button>
          </div>
        </div>
      </div>
    </div>
  </nav>
